import GridBox from '@components/atoms/GridBox';
import Spacing from '@components/atoms/Spacing';
import ROUTES from '@lib/constants/routes';
import { isValidPhone } from '@lib/helpers/misc';
import PrimaryButton from 'components/atoms/buttons/PrimaryButton';
import FormField from 'components/atoms/FormField';
import TextField from 'components/atoms/TextField';
import { Heading1, Paragraph } from 'components/atoms/Typography';
import { useRouter } from 'next/router';
import React from 'react';
import { useForm } from 'react-hook-form';

const SignInForm = () => {
  const router = useRouter();

  const { register, handleSubmit, errors } = useForm<{ tel: string }>();

  const redirect = router.query.redirect?.toString();

  return (
    <>
      <Heading1 center>Acesse ou crie sua conta</Heading1>
      {!router.query.phone && (
        <Spacing top={2}>
          <Paragraph center>
            Digite seu celular para entrar. Seus dados estão seguros e você não
            precisa de senha.
          </Paragraph>
        </Spacing>
      )}
      <form
        onSubmit={handleSubmit((data) => {
          router.push(
            `${ROUTES.signIn}/${data.tel}${
              redirect ? `?redirect=${redirect}` : ''
            }`,
          );
        })}
      >
        <GridBox justifyContent="center">
          <GridBox width={[1, 0.5, 0.5]}>
            <FormField style={{ width: '100%' }}>
              <TextField
                placeholder="Número do Celular"
                inputRef={register({
                  required: 'Precisamos de um número',
                  validate: {
                    valid: (phone) =>
                      isValidPhone(phone) || 'Precisamos de um número válido',
                  },
                })}
                type="tel"
                autoComplete="tel tel-national"
                errorMessage={errors?.tel?.message}
                name="tel"
                mask={[
                  '(',
                  /\d/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
              />
            </FormField>
          </GridBox>
        </GridBox>
        <GridBox justifyContent="center">
          <GridBox width={[1, 0.5, 0.5]}>
            <PrimaryButton isBlock style={{ marginTop: 32 }} pink>
              Receber Código por SMS
            </PrimaryButton>
          </GridBox>
        </GridBox>
      </form>
    </>
  );
};

export default SignInForm;
